
import { useState } from 'react';
import EnhancedAdvancedAnalysisCard from './EnhancedAdvancedAnalysisCard';
import AdvancedAnalysisModal from './AdvancedAnalysisModal';

interface AdvancedAnalysisButtonProps {
  bigFiveResultId: string;
  testResults: any;
  onAnalysisComplete?: (analysis: any, insight: any) => void;
}

export default function AdvancedAnalysisButton({ 
  bigFiveResultId, 
  testResults, 
  onAnalysisComplete 
}: AdvancedAnalysisButtonProps) {
  const [analysis, setAnalysis] = useState<any>(null);
  const [insight, setInsight] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);

  const handleAnalysisComplete = (result: any) => {
    if (result?.analysis && result?.insight) {
      setAnalysis(result.analysis);
      setInsight(result.insight);
      setShowModal(true);
      
      if (onAnalysisComplete) {
        onAnalysisComplete(result.analysis, result.insight);
      }
    }
  };

  const analysisData = {
    bigFiveResultId,
    testResults
  };

  const features = [
    'Perfil psicológico detalhado',
    'Análise de padrões comportamentais',
    'Identificação de mecanismos de defesa',
    'Vulnerabilidades e pontos de atenção',
    'Forças e recursos internos',
    'Recomendações terapêuticas personalizadas',
    'Insights psicanalíticos profundos',
    'Plano de desenvolvimento pessoal'
  ];

  return (
    <>
      <EnhancedAdvancedAnalysisCard
        title="Análise Psicológica Avançada"
        description="Análise psiquiátrica e psicanalítica detalhada baseada nos seus resultados do Big Five"
        cost={30}
        data={analysisData}
        functionName="personality-advanced-analysis"
        onAnalysisComplete={handleAnalysisComplete}
        estimatedTime="2-3 min"
        features={features}
      />

      {showModal && analysis && insight && (
        <AdvancedAnalysisModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          analysis={analysis}
          insight={insight}
        />
      )}
    </>
  );
}
